/* Drop countdown ticker (pilot 9/19/2026). See snippets/drop-countdown.liquid */
(function () {
  if (window.__dropCountdown) return;
  window.__dropCountdown = true;

  var dataEl = document.getElementById('drop-countdown-data');
  if (!dataEl) return;
  var ends;
  try {
    ends = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var handles = Object.keys(ends);
  if (!handles.length) return;

  function handleFromHref(href) {
    try {
      var path = new URL(href, location.origin).pathname;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function makeBadge(handle, context) {
    var el = document.createElement('span');
    el.className = 'drop-countdown drop-countdown--' + context;
    el.setAttribute('data-drop-handle', handle);
    el.setAttribute('role', 'timer');
    el.setAttribute('aria-live', 'off');
    var d = new Date(ends[handle] * 1000);
    el.setAttribute('aria-label', 'Drop ends ' + d.toLocaleString());
    return el;
  }

  var pdpHandle = handleFromHref(location.href);
  var isPdp = !!(pdpHandle && ends[pdpHandle] && /\/products\//.test(location.pathname));

  function attach() {
    // Product cards in any grid (collection, search, recommendations, homepage)
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var media = card.querySelector('.card__media');
      if (!media || media.querySelector('.drop-countdown')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFromHref(link.getAttribute('href'));
      if (handle && ends[handle]) media.appendChild(makeBadge(handle, 'card'));
    });

    // Available Now grid cards (sections/an-product-grid.liquid): badge sits on the image link
    document.querySelectorAll('.an-card').forEach(function (card) {
      var media = card.querySelector('.an-card__media');
      if (!media || media.querySelector('.drop-countdown')) return;
      var handle = handleFromHref(media.getAttribute('href') || '');
      if (handle && ends[handle]) media.appendChild(makeBadge(handle, 'card'));
    });

    // Available Now hero featured card (sections/an-hero.liquid)
    document.querySelectorAll('.an-hero__card').forEach(function (card) {
      if (card.querySelector('.drop-countdown')) return;
      var handle = handleFromHref(card.getAttribute('href') || '');
      if (handle && ends[handle]) card.appendChild(makeBadge(handle, 'hero'));
    });

    // Product page: first image in the gallery
    if (isPdp) {
      document.querySelectorAll('.product__media-list').forEach(function (list) {
        if (list.querySelector('.drop-countdown')) return;
        var first = list.querySelector('.product__media-item.is-active') || list.querySelector('.product__media-item');
        if (first) first.appendChild(makeBadge(pdpHandle, 'pdp'));
      });
    }
  }

  function fmt(s) {
    var d = Math.floor(s / 86400),
      h = Math.floor((s % 86400) / 3600),
      m = Math.floor((s % 3600) / 60),
      sec = s % 60;
    var ss = (sec < 10 ? '0' : '') + sec;
    if (d > 0) return 'Gone in ' + d + 'd ' + h + 'h ' + m + 'm ' + ss + 's';
    if (h > 0) return 'Gone in ' + h + 'h ' + m + 'm ' + ss + 's';
    return 'Gone in ' + m + 'm ' + ss + 's';
  }

  function endDrop(el) {
    el.classList.add('is-gone');
    el.textContent = 'Gone';
    if (el.classList.contains('drop-countdown--pdp')) {
      document
        .querySelectorAll('.product-form__buttons, .shopify-payment-button, .product-form__submit')
        .forEach(function (b) {
          b.classList.add('drop-ended-hide');
        });
      var form = document.querySelector('.product__info-container product-form, .product__info-container .product-form');
      if (form && !document.querySelector('.drop-ended-note')) {
        var note = document.createElement('p');
        note.className = 'drop-ended-note';
        note.textContent = 'This drop has ended. Catch the next one on our Instagram live.';
        form.parentNode.insertBefore(note, form);
      }
    } else {
      var card = el.closest('.card-wrapper');
      if (card) {
        card.querySelectorAll('.quick-add, .quick-add__submit').forEach(function (b) {
          b.classList.add('drop-ended-hide');
        });
      }
      // Available Now grid card: hide the add-to-cart pill (and "Choose options" link)
      var anCard = el.closest('.an-card');
      if (anCard) {
        anCard.querySelectorAll('.an-card__form, .an-card__button').forEach(function (b) {
          b.classList.add('drop-ended-hide');
        });
      }
    }
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('.drop-countdown[data-drop-handle]').forEach(function (el) {
      var left = ends[el.getAttribute('data-drop-handle')] - now;
      if (left <= 0) {
        if (el.getAttribute('data-ended') !== '1') {
          el.setAttribute('data-ended', '1');
          endDrop(el);
        }
        return;
      }
      var txt = fmt(left);
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  function run() {
    attach();
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setInterval(tick, 1000);

  // Re-attach when grids re-render (filters, sorting, recommendations, theme editor)
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    var relevant = mutations.some(function (m) {
      return !(m.target.closest && m.target.closest('.drop-countdown')) && !(m.target.classList && m.target.classList.contains('drop-countdown'));
    });
    if (!relevant) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      run();
    }, 150);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
